import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupHasFrontProfileService } from '@services/groups/group-has-frontprofile.service';
import { DataTableComponent } from '../../../components/data-table/data-table.component';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { FrontProfileSelectionComponent } from '../../../components/popUpSelects/front-profile-selection/front-profile-selection.component';
import * as _ from 'lodash';

@Component({
    selector: 'app-front-group-edit',
    templateUrl: './front-group-edit.component.html',
    styleUrls: ['./front-group-edit.component.scss'],
    providers: [GroupHasFrontProfileService],
    standalone: false
})
export class FrontGroupEditComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  public columns = [{ prop: 'firstName' }, { prop: 'lastName' }, { prop: 'email' }, { prop: 'mobile' }];

  pageActions;
  groupHasFrontProfiles: Models.GroupHasFrontProfile[];
  params: any;
  groupName = '';

  constructor(
    private router: Router, private route: ActivatedRoute, public groupHasFrontProfilesService: GroupHasFrontProfileService, private snackbar: SnackbarService, private dialog: MatDialog
  ) {
    this.params = { GroupID: this.route.snapshot.params['groupID'] };
  }

  ngOnInit(): void {
    this.groupHasFrontProfilesService.find(0, 1, this.params).then(res => {
      if (res && res.data && res.data[0] && res.data[0].groupName) {
        this.groupName = res.data[0].groupName;
      }
    })
    this.createPageActions();
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Overview',
        translationString: 'general.back',
        callback: () => {
          this.router.navigate(['my-users', this.route.snapshot.params['packageId']]);
        }
      })
    ];
  }

  addProfiles() {
    this.groupHasFrontProfilesService.find(0, 1000, this.params).then(groupHasFrontProfiles => {
      this.groupHasFrontProfiles = groupHasFrontProfiles.data;
      const dialogRef = this.dialog.open(FrontProfileSelectionComponent, {
        data: {
          packageId: this.route.snapshot.params['packageId'],
          selectedProfileIds: _.map(groupHasFrontProfiles.data, 'ProfileID')
        },
        width: '800px'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (!result || !result.added || !result.removed) {
          return;
        }
        let promise = Promise.resolve();
        const finishedRemoves = [];
        const finishedAdds = [];
        for (const id of result.removed) {
          const element = _.filter(this.groupHasFrontProfiles, { 'ProfileID': id })[0];
          if (element) {
            (el => {
              promise = promise.then(() => {
                return this.groupHasFrontProfilesService.remove(el['ID'].toString()).then(() => {
                  finishedRemoves.push(el['ProfileID'].toString());
                  return;
                });
              });
            })(element);
          }
        }
        for (const id of result.added) {
          (i => {
            const data = new Models.GroupHasFrontProfile();
            data.populateFromJSON({
              GroupID: this.route.snapshot.params['groupID'],
              ProfileID: i
            });
            promise = promise.then(() => {
              return this.groupHasFrontProfilesService.create(data).then(res => {
                finishedAdds.push(res.ID);
                return;
              }).catch(err => {
                if (err && err.error && err.error.message) {
                  try {
                    let message = JSON.parse(err.error.message);
                    message = message.reason;
                    if (message === 'tooManyChat') {
                      return this.rollback(finishedAdds, finishedRemoves).then(() => {
                        throw new Error();
                      });
                    } else {
                      console.error(err);
                    }
                  } catch (parseErr) {
                    console.error(err, parseErr);
                  }
                }
              });
            });
          })(id);
        }
        promise.then(() => {
          this.snackbar.success('Profiles have been added to Group');
          this.table.refresh();
        }).catch(err => {
          const text = 'Profiles have not been added/removed to Group because Chat Profile Limit was reached, please remove unused chat profiles or contact [EMAIL ADDRESS]'
          this.snackbar.open(text, 10000);
          this.table.refresh();
        });
      });
    });
  }

  removeProfile(event) {
    this.groupHasFrontProfilesService.remove(event.row.ID).then(() => {
      this.table.refresh();
    });
  }

  rollback(remove, add): Promise<any> {
    let promise: Promise<any> = Promise.resolve();
    if (remove.length) {
      for (const id of remove) {
        (i => {
          promise = promise.then(() => {
            return this.groupHasFrontProfilesService.remove(i);
          });
        })(id);
      }
    }
    if (add.length) {
      for (const id of add) {
        (i => {
          promise = promise.then(() => {
            const data = new Models.GroupHasFrontProfile();
            data.populateFromJSON({
              GroupID: this.route.snapshot.params['groupID'],
              ProfileID: i
            });
            return this.groupHasFrontProfilesService.create(data);
          });
        })(id);
      }
    }
    return promise;
  }

}
